import React from 'react';
import './shared.css';
import Footer from './Footer';
import TopNav from './TopNav';

function Disclaimer() {
  return (
    <div className="min-h-screen w-full bg-gray-50">
      {/* Top Navigation */}
      <TopNav activePage="disclaimer" />

      {/* Header Section */}
      <div className="App-header" style={{ background: '#1f2937', minHeight: '30vh' }}>
        <h1 style={{ fontSize: '2.5rem', fontWeight: 700, marginBottom: '1rem', textAlign: 'center' }}>
          📋 Disclaimer & Legal Notice
        </h1>
        <p style={{ fontSize: '1.1rem', opacity: 0.9, maxWidth: '900px', textAlign: 'center', lineHeight: 1.6 }}>
          Important information about this site, the resources it contains, and how to use them responsibly.
        </p>
      </div>

      {/* Main Content */}
      <div className="responsive-px" style={{ paddingTop: '2rem', paddingBottom: '2rem' }}>
        <div style={{ maxWidth: '900px', margin: '0 auto' }}>

          {/* Copyright & Affiliation Section */}
          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: '1rem', color: '#1f2937' }}>
              1. Copyright & Affiliation
            </h2>
            <div style={{ fontSize: '1rem', lineHeight: 1.8, color: '#374151', gap: '1rem', display: 'flex', flexDirection: 'column' }}>
              <p>
                <strong>All past papers, mark schemes, and related materials are © Cambridge Assessment International Education (CAIE)</strong> and 
                <strong> © Pearson Edexcel</strong> respectively.
              </p>
              <p>
                I organize these resources for <strong>educational purposes only</strong>. This tool is <strong>not affiliated with, endorsed by, or connected to CAIE or Edexcel</strong>.
              </p>
              <p>
                The content remains the intellectual property of its original creators. This site simply aggregates and provides access to publicly available materials for students and educators.
              </p>
            </div>
          </section>

          {/* YouTube Solutions Section */}
          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: '1rem', color: '#1f2937' }}>
              2. YouTube Solutions & External Content
            </h2>
            <div style={{ fontSize: '1rem', lineHeight: 1.8, color: '#374151', gap: '1rem', display: 'flex', flexDirection: 'column' }}>
              <p>
                This site provides links to YouTube video solutions created by various content creators. These videos are linked for educational reference only.
              </p>
              <p>
                <strong>Important:</strong>
              </p>
              <ul style={{ marginLeft: '1.5rem', gap: '0.5rem', display: 'flex', flexDirection: 'column' }}>
                <li>• YouTube content is © their respective creators and YouTube</li>
                <li>• I do not create, host, or monetize these videos</li>
                <li>• I am not responsible for the accuracy or quality of external video content</li>
                <li>• Video links may change or become unavailable at any time</li>
                <li>• Always verify solutions independently and check official mark schemes</li>
              </ul>
              <p>
                If you are a content creator and wish to have your content removed or credited differently, please reach out and I will address it promptly.
              </p>
            </div>
          </section>

          {/* Difficulty Rating Section */}
          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: '1rem', color: '#1f2937' }}>
              3. Difficulty Ratings
            </h2>
            <div style={{ fontSize: '1rem', lineHeight: 1.8, color: '#374151', gap: '1rem', display: 'flex', flexDirection: 'column' }}>
              <p>
                The difficulty ratings displayed on this site are <strong>my own calculations and assessments</strong>, based on grade thresholds data.
              </p>
              <p>
                <strong>These ratings are NOT official and should not be treated as authoritative.</strong> Difficulty can vary greatly depending on:
              </p>
              <ul style={{ marginLeft: '1.5rem', gap: '0.5rem', display: 'flex', flexDirection: 'column' }}>
                <li>• Your individual strengths and weaknesses</li>
                <li>• Your preparation and revision coverage</li>
                <li>• Your familiarity with the exam format</li>
                <li>• The specific topics tested in that paper</li>
              </ul>
              <p>
                Use these ratings as a rough guide only. Always practice papers across all difficulty levels to build comprehensive exam readiness.
              </p>
            </div>
          </section>

          {/* Usage & Responsibility Section */}
          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: '1rem', color: '#1f2937' }}>
              4. Responsible Usage
            </h2>
            <div style={{ fontSize: '1rem', lineHeight: 1.8, color: '#374151', gap: '1rem', display: 'flex', flexDirection: 'column' }}>
              <p>
                This site is designed to support student learning. Please use it responsibly:
              </p>
              <ul style={{ marginLeft: '1.5rem', gap: '0.5rem', display: 'flex', flexDirection: 'column' }}>
                <li>• Practice papers under timed conditions for best exam preparation</li>
                <li>• Always attempt questions before checking solutions</li>
                <li>• Mark yourself honestly using official mark schemes</li>
                <li>• Focus on understanding, not just getting answers right</li>
                <li>• Respect academic integrity rules at your school/institution</li>
                <li>• Use solutions as learning tools, not as shortcuts</li>
              </ul>
            </div>
          </section>

          {/* Accuracy & Liability Section */}
          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: '1rem', color: '#1f2937' }}>
              5. Accuracy & Liability
            </h2>
            <div style={{ fontSize: '1rem', lineHeight: 1.8, color: '#374151', gap: '1rem', display: 'flex', flexDirection: 'column' }}>
              <p>
                While I strive to ensure accuracy and keep content up-to-date, I cannot guarantee:
              </p>
              <ul style={{ marginLeft: '1.5rem', gap: '0.5rem', display: 'flex', flexDirection: 'column' }}>
                <li>• All papers and mark schemes are correctly indexed</li>
                <li>• External links remain functional and up-to-date</li>
                <li>• Video solutions are accurate or complete</li>
                <li>• Difficulty ratings apply universally to all students</li>
              </ul>
              <p>
                <strong>Always verify with official sources:</strong> Check CAIE and Edexcel official websites for the most current and authoritative versions of papers and mark schemes.
              </p>
              <p>
                I am not liable for any educational outcomes, grades, or decisions made based on information from this site.
              </p>
            </div>
          </section>

          {/* Contact Section */}
          <section style={{ marginBottom: '2.5rem', padding: '1.5rem', background: '#fef3c7', borderRadius: '8px', border: '1px solid #fcd34d' }}>
            <h2 style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: '1rem', color: '#92400e' }}>
              6. Questions or Concerns?
            </h2>
            <div style={{ fontSize: '1rem', lineHeight: 1.8, color: '#78350f' }}>
              <p>
                If you have concerns about content accuracy, copyright issues, broken links, or suggestions for improvement, please reach out. I'm committed to maintaining a fully free, helpful and responsible resource for students.
              </p>
            </div>
          </section>

        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
}

export default Disclaimer;
